import * as actionTypes from 'src/old/actions';

const initialState = {
  superAdmins: []
};

const superAdminReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FETCH_SUPER_ADMINS: {
      return {
        ...state,
        superAdmins: action.response
      };
    }

    case actionTypes.POST_SUPER_ADMIN: {
      return {
        ...state,
        superAdmins: [...state.superAdmins, action.response]
      };
    }

    case actionTypes.DELETE_SUPER_ADMIN: {
      return {
        ...state,
        superAdmins: [...state.superAdmins].filter(x => x.email !== action.response?.email)
      };
    }

    case actionTypes.RESET_SUPER_ADMIN_PASSWORD: {
      return {
        ...state
      };
    }

    default: {
      return state;
    }
  }
};

export default superAdminReducer;
